if (!customElements.get('loyalty-tiers-carousel')) {
  customElements.define(
    'loyalty-tiers-carousel',
    class LoyaltyTiersCarousel extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-carousel-list]');
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        if (!this.list || this.dots.length === 0) return;

        this.items = Array.from(this.list.children);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index, true)));
        this.list.addEventListener('scroll', () => this.onScroll(), { passive: true });

        // Logged-in customers start at their current level, guests at the first one
        const start = parseInt(this.dataset.start, 10) || 0;
        if (start > 0) requestAnimationFrame(() => this.goTo(start, false));
      }

      onScroll() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateDots());
      }

      // The list only scrolls on mobile; on desktop scrollTo does nothing
      goTo(index, smooth) {
        const item = this.items[index];
        if (!item) return;
        const paddingLeft = parseFloat(getComputedStyle(this.list).paddingLeft) || 0;
        this.list.scrollTo({ left: item.offsetLeft - paddingLeft, behavior: smooth ? 'smooth' : 'auto' });
      }

      updateDots() {
        if (this.items.length < 2) return;
        const step = this.items[1].offsetLeft - this.items[0].offsetLeft;
        if (step <= 0) return;
        const maxIndex = this.items.length - 1;
        const atEnd = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 2;
        const index = atEnd ? maxIndex : Math.min(maxIndex, Math.round(this.list.scrollLeft / step));
        this.dots.forEach((dot, i) => {
          if (i === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
